export default function Relatorio1() {
    return (
      <div className="p-8">
        <h1 className="text-2xl font-bold">Relatório 1</h1>
        <p>Conteúdo do relatório 1.</p>
      </div>
    );
  }
  